import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-10" }
const _hoisted_2 = { class: "lg:col-span-5" }
const _hoisted_3 = { class: "lg:col-span-7" }
const _hoisted_4 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-16" }
const _hoisted_5 = { class: "flex gap-4" }
const _hoisted_6 = {
  class: "w-5 h-5 flex-shrink-0 mt-1",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = ["fill"]

import { computed } from "vue";
import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import { PageBlock } from "@/views/blocks/PageBlock.interface";
import EditableElement from "@/views/page/EditableElement.vue";

// Import shared components
import Section from "@/views/blocks/shared/section/layout/section/Section.vue";
import FullSpacing from "@/views/blocks/shared/section/layout/spacing/FullSpacing.vue";
import Heading from "@/views/blocks/shared/section/typography/heading/Heading.vue";
import Paragraph from "@/views/blocks/shared/section/typography/paragraph/Paragraph.vue";

import type { OffsetWithFeatureListProps } from "./OffsetWithFeatureListProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'OffsetWithFeatureList',
  props: {
    block: {},
    pageColors: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Section, {
    id: _ctx.block.webId,
    "background-color": styleValues.value.background
  }, {
    default: _withCtx(() => [
      _createVNode(FullSpacing, { class: "max-w-7xl mx-auto" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (!dataValues.value.tag.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    blockId: _ctx.block.id,
                    "field-name": "tag"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", {
                        style: _normalizeStyle({ color: styleValues.value.brand }),
                        class: "font-semibold mb-4"
                      }, _toDisplayString(dataValues.value.tag.data.text), 5)
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.title.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 1,
                    blockId: _ctx.block.id,
                    "field-name": "title"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Heading, {
                        text: dataValues.value.title.data.text,
                        tag: dataValues.value.title.data.tag,
                        "text-color": styleValues.value.text,
                        class: "mb-6 text-4xl sm:text-5xl"
                      }, null, 8, ["text", "tag", "text-color"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.description.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 2,
                    blockId: _ctx.block.id,
                    "field-name": "description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Paragraph, {
                        text: dataValues.value.description.data.text,
                        "text-color": styleValues.value.text,
                        class: "text-lg opacity-70"
                      }, null, 8, ["text", "text-color"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.features.data.items, (feature) => {
                  return (_openBlock(), _createBlock(EditableElement, {
                    key: feature.id,
                    blockId: _ctx.block.id,
                    "field-name": `features_${feature.id}`,
                    hideable: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                          _createElementVNode("path", {
                            d: "M16.7071 4.29289C17.0976 4.68342 17.0976 5.31658 16.7071 5.70711L8.70711 13.7071C8.31658 14.0976 7.68342 14.0976 7.29289 13.7071L3.29289 9.7071C2.90237 9.31658 2.90237 8.68342 3.29289 8.29289C3.68342 7.90237 4.31658 7.90237 4.70711 8.29289L8 11.5858L15.2929 4.29289C15.6834 3.90237 16.3166 3.90237 16.7071 4.29289Z",
                            fill: styleValues.value.brand
                          }, null, 8, _hoisted_7)
                        ])),
                        _createElementVNode("div", null, [
                          _createVNode(Paragraph, {
                            text: feature.title,
                            "text-color": styleValues.value.text,
                            class: "font-semibold mb-2"
                          }, null, 8, ["text", "text-color"]),
                          _createVNode(Paragraph, {
                            text: feature.description,
                            "text-color": styleValues.value.text,
                            class: "text-base/7 opacity-70"
                          }, null, 8, ["text", "text-color"])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["blockId", "field-name"]))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "background-color"]))
}
}

})